import React, { Component } from 'react';
import JobsAssignment from './Commons/JobsAssignment.js'

export default class TransferJobs extends Component {
	render() {
		return (
			<div>
				<JobsAssignment operationName={'Transfer'} processType={'INTRA_WAREHOUSE_TRANSFER'} userType={'INWARDING'} processPhase={'INWARDING_PICK'} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/TransferJobs.js